import { useCallback, useState } from 'react';
import { isRequestError } from '#shared/lib/requests';
import { showSuccess } from '#shared/lib/toast';
import { importCharacteristicGroups } from '../api';

export const useCharacteristicGroupsImport = ({
    setErrorMessage,
    setErrorFileId,
    afterImport,
}: {
    setErrorMessage: (message: string) => void;
    setErrorFileId: (fileId: string) => void;
    afterImport: VoidFunction;
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const importGroups = useCallback(
        async (file?: File) => {
            if (!file) {
                setErrorMessage('Обязательное поле');

                return;
            }

            if (isLoading) {
                return;
            }

            const formData = new FormData();

            formData.append('file', file);

            try {
                setIsLoading(true);

                const data = await importCharacteristicGroups(formData);

                if (data?.success !== true) {
                    if (data?.errors_file_id) {
                        setErrorFileId(data.errors_file_id);
                    }

                    throw new Error();
                }

                afterImport();
                showSuccess('Группировка характеристик обновлена');
            } catch (error) {
                if (isRequestError(error)) {
                    setErrorMessage(error.responseData.message);
                } else {
                    setErrorMessage('Не удалось загрузить файл');
                }
            } finally {
                setIsLoading(false);
            }
        },
        [setErrorMessage, afterImport, isLoading, setErrorFileId]
    );

    return { isLoading, importGroups };
};
